import React, { useCallback, useEffect, useRef } from 'react'
import { Button } from '@mui/material';
import html2canvas from 'html2canvas';
import NavBar from '../../Components/NavBar/navbar'
import FooterSection from '../../Components/Footer/footer'
import axios from "axios";
import { MOBILITY_SERVICE_BASE_URL } from '../../utils/config';

const Game = () => {
    const iframeRef = useRef(null);

    const sendInputToGame = useCallback((input) => {
        if (!iframeRef.current) return;
        const iframeWindow = iframeRef.current.contentWindow;
        const iframeDocument = iframeWindow.document;

        const script = document.createElement('script');
        script.textContent = `
    document.addEventListener('dblclick', function(event) {
        const marker = document.createElement('div');
        marker.style.position = 'absolute';
        marker.style.width = '50px';
        marker.style.height = '50px';
        marker.style.backgroundColor = 'red';
        marker.style.borderRadius = '100%';
        marker.style.pointerEvents = 'none';
        marker.style.transform = 'translate(-50%, -50%)';
        marker.style.left = \`\${event.clientX}px\`;
        marker.style.top = \`\${event.clientY}px\`;
        document.body.appendChild(marker);
        setTimeout(() => marker.remove(), 1000);

        console.log("here",event.clientX,event.clientY)
    });

    function simulateClick(x, y) {
            const iframeX = x;
            const iframeY = y;

            const event = new MouseEvent('mousedown', {
                clientX: iframeX,
                clientY: iframeY,
                bubbles: true,
                button: 0
            });

            document.dispatchEvent(event);

            const event3 = new MouseEvent('dblclick', {
                clientX: iframeX,
                clientY: iframeY,
                bubbles: true,
                button: 0
            });

            document.dispatchEvent(event3);

            const event2 = new MouseEvent('mouseup', {
                clientX: iframeX,
                clientY: iframeY,
                bubbles: true,
                button: 0
            });

            document.dispatchEvent(event2);
        }
`;
        iframeDocument.head.appendChild(script);
        console.log(input)
        if (input.type === 'keydown') {
            if (input.key === "Space") {
                const keydownEvent = new KeyboardEvent('keydown', { key: ' ', code: 'Space', keyCode: 32 });
                iframeWindow.dispatchEvent(keydownEvent);

                const keyupEvent = new KeyboardEvent('keyup', { key: ' ', code: 'Space', keyCode: 32 });
                iframeWindow.dispatchEvent(keyupEvent);
            } else {
                const event = new KeyboardEvent('keydown', { key: input.key });
                iframeWindow.dispatchEvent(event);
            }
        } else if (input.type === 'click') {
            const event = new MouseEvent('click', {
                clientX: input.clientX,
                clientY: input.clientY,
            });
            iframeWindow.dispatchEvent(event);
        }
    }, []);

    useEffect(() => {
        const intervalId = setInterval(async () => {
            const { data: input } = await axios.get(`${MOBILITY_SERVICE_BASE_URL}/random_control`)
            sendInputToGame(input)
        }, 5000);

        return () => clearInterval(intervalId);
    }, [sendInputToGame]);

    const get_db = () => {
        try {
            const request = indexedDB.open('c3-localstorage-j8ytefnmni59')
            console.log(request)

            request.onsuccess = (event) => {
                const db = event.target.result;
                const transaction = db.transaction(['keyvaluepairs'], 'readonly');
                const objectStore = transaction.objectStore('keyvaluepairs');

                const allEntries = [];

                const cursorRequest = objectStore.openCursor();

                cursorRequest.onsuccess = (event) => {
                    const cursor = event.target.result;
                    if (cursor) {
                        allEntries.push({ key: cursor.key, value: cursor.value });
                        cursor.continue();
                    } else {
                        console.log('All entries:', allEntries);
                    }
                };

                cursorRequest.onerror = (event) => {
                    console.error('Error opening cursor:', event);
                };
            };
            request.onerror = (event) => {
                console.error('Error opening IndexedDB:', event);
            };

        } catch (error) {
            console.log(error)
        }
    }

    const downloadImage = (imgData, filename) => {
        const link = document.createElement('a');
        link.href = imgData;
        link.download = filename;
        link.click();
    };

    const captureIframe = async () => {
        const iframe = document.querySelector('iframe');
        const iframeContent = iframe.contentWindow.document.body;

        const html5 = iframeContent.getElementsByClassName('c3htmlwrap')
        html2canvas(html5).then(function (canvas) {
            const imgData = canvas.toDataURL('image/png');
            downloadImage(imgData, "screenshot")
        }).catch(function (error) {
            console.error('Error capturing screenshot:', error);
            alert("Couldn't capture a screenshot.");
        });
    };

    return (
        <div className="main" >
            <NavBar />

            <div style={{ marginTop: "100px" }}>
                <iframe
                    title="Santa Drop game"
                    ref={iframeRef}
                    src="sgd/index.html"
                    width={1280}
                    height={720}
                ></iframe>
            </div>
            <Button variant="contained" onClick={captureIframe}>
                Capture and Download Image
            </Button>

            <Button
                variant="contained" onClick={get_db}>
                Download DB
            </Button>
            <FooterSection />
        </div>
    );
}

export default Game;
